module.exports = __webpack_public_path__ + "static/img/Bitmap.6cee738.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dealer/Bitmap.png
// module id = Ja8e
// module chunks = 1